import { ADDRESS_CHANGE_MODE, ADDRESS_ERROR, ADDRESS_RECEIVE, ViewMode, } from '../constants';
import { error as errorReducer } from './Error.reducer';
/**
 * @type {{mode: string, list: *[], errors: {}}}
 */
const defaultState = {
    list: [],
    mode: ViewMode.List,
    errors: {},
};
export const address = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ADDRESS_RECEIVE:
        case ADDRESS_CHANGE_MODE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case ADDRESS_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
